import StadiaMapsClass, * as StadiaMapsModule from './../../node_modules/ol/source/StadiaMaps.js';

class StadiaMaps extends StadiaMapsClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in StadiaMapsModule) {
    if (key !== "default") {
        StadiaMaps[key] = StadiaMapsModule[key];
    }
}

export default StadiaMaps;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/StadiaMaps.js';